var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleLineWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 1600 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1245_3734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1931 198.497C1720.1 114.164 1270.19 34.8691 830.847 99.0781C251.5 183.748 -60.3101 -42.8989 -282.08 -50.6579",
    stroke: "#fff",
    strokeWidth: 2.5,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842 128.354C1625.05 61.096 1170.25 17.907 737.422 116.922C166.67 247.491 -162.21 46.413 -383.9 56.352",
    stroke: "#150d6b",
    strokeWidth: 2.5,
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1245_3734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 170,
    fill: "white",
    transform: "translate(1600 170) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleLineWave);
export default __webpack_public_path__ + "static/media/singleLineWave.aa4143760b59b8be490b853262a739f9.svg";
export { ForwardRef as ReactComponent };